import { useState } from '@wordpress/element'; 
import { __ } from '@wordpress/i18n';
import { __experimentalHStack as HStack,
    __experimentalText as Text,
    __experimentalToolsPanel as ToolsPanel,
    __experimentalToolsPanelItem as ToolsPanelItem,
    Button, Popover,
} from '@wordpress/components';

const Navigation = ({ navigationValue, onnavigationChange }) => {
    const [isimageVisible, setIsimageVisible] = useState(false);
    const [imagepopoverAnchor, setimagePopoverAnchor] = useState();
    const [imageselectedAnimation, imagesetSelectedAnimation] = useState(navigationValue || 'none'); // Default to 'none'

    // Function to toggle the visibility of the popover
    const imagetoggleVisible = () => {
        setIsimageVisible((prev) => !prev);
    };

    const handleimageAnimationClick = (animation) => {
        imagesetSelectedAnimation(animation);
        onnavigationChange(animation); // Update the parent component with the new animation value
    };

    let imagename = '';
    const imageanimationoptions = [
        {
            label: __( 'Default', 'vayu-blocks' ),
            value: 'default'
        },
        {
            label: __( 'Numbers', 'vayu-blocks' ),
            value: 'numbers'
        },
        {
            label: __( 'Bullets', 'vayu-blocks' ),
            value: 'bullets'
        },
        {
            label: __( 'ProgressBar', 'vayu-blocks' ),
            value: 'progressbar'
        }
    ];

    // Find the label based on imageselectedAnimation
    const imageselectedOption = imageanimationoptions.find(option => option.value === imageselectedAnimation);
    
    if (imageselectedOption) {
        imagename = imageselectedOption.label;
    }

    const sliderComponents = {
        Default: (
            <Text>
                <div className="vayu-blocks-slider-default-parent">
                    <div className="vayu-blocks-slider-default"></div>
                    <div className="vayu-blocks-slider-default"></div>
                </div>
            </Text>
        ),
        Numbers: (
            <Text style={{marginTop: '6px'}}>
            <div className="vayu-blocks-slider-default-parent-numbers">
                <div className="vayu-blocks-slider-default-numbers">1/2</div>
            </div></Text>
        ),
        Bullets: (
            <Text><div className="vayu-blocks-slider-default-parent-bullets">
                <div className="vayu-blocks-slider-default-bullets"></div>
                <div className="vayu-blocks-slider-default-bullets vayu-blocks-bullets-effect-slider"></div>
            </div></Text>
        ),
        ProgressBar: (
            <Text style={{ marginLeft: '13px',marginTop: '5px','width': '100%'}}><div className="vayu-blocks-slider-default-parent-progressbar">
                <div className="vayu-blocks-slider-default-progressbar"></div>
                <div className="vayu-blocks-slider-default-progressbar vayu-blocks-progressbar-effect-slider"></div>
            </div></Text>
        ),
    };
    
    return (
        <div className="vayu_blocks_animation_panel">
            <ToolsPanel label={__('Pagination Type')} className="vayu_block_animation_name">
                <ToolsPanelItem
                    className="vayu_blocks_animation_toolspanel_item"
                    hasValue={() => !!navigationValue}
                    label={__('Effect')}
                    onDeselect={() => onnavigationChange(undefined)}
                    isShownByDefault
                >
                    <Button
                        ref={setimagePopoverAnchor}
                        onClick={imagetoggleVisible}
                        className={`block-editor-panel-animation-settings__dropdown ${isimageVisible ? 'is-open' : ''}`}
                    >
                        <HStack alignment="left" style={{gap:'17px'}}>
                            <Text>{__(imagename)} </Text>

                            {sliderComponents[imagename] || null} {/* Render based on imageName */}
                            
                        </HStack>
                    </Button>
                </ToolsPanelItem>
            </ToolsPanel>

            {isimageVisible && (
                <Popover
                    placement="left-start"
                    className="vayu_blocks_toolspanel_items_popover"
                    anchor={imagepopoverAnchor}
                    onClose={() => setIsimageVisible(false)}
                    offset={35}
                    resize
                >
                    <div className="vayu_blocks_div_animation">
                        <h4>{__('Pagination')}</h4>
                        <p>{__('Select an pagination type for your element.')}</p>
                            <Button
                                key={'default'}
                                style={{margin:'3px'}}
                                className={`vayu_blocks_animation_panel_button_svg vayu_blocks_animation_panel_button_svg-effect ${imageselectedAnimation === 'default' ? 'selected' : ''}`}
                                onClick={() => handleimageAnimationClick('default')}
                                title={'default'}
                            >
                                <div style={{flexDirection:'column'}} className={`vayu_blocks_animation_panel_svg vayu_blocks_animation_panel_svg-effect vayu-blocks-effect-slider-default `}>
                                <h4>Default</h4>
                                    <div className='vayu-blocks-slider-default-parent'>
                                        <div className='vayu-blocks-slider-default'></div>
                                        <div className='vayu-blocks-slider-default'></div>
                                    </div>
                                </div>
                            </Button>

                       
                            <Button
                                style={{margin:'3px'}}
                                key={'numbers'}
                                className={`vayu_blocks_animation_panel_button_svg vayu_blocks_animation_panel_button_svg-effect ${imageselectedAnimation === 'numbers' ? 'selected' : ''}`}
                                onClick={() => handleimageAnimationClick('numbers')}
                                title={'numbers'}
                            >
                                <div style={{flexDirection:'column'}} className={`vayu_blocks_animation_panel_svg vayu_blocks_animation_panel_svg-effect vayu-blocks-effect-slider-numbers`}>
                                <h4>Numbers</h4>

                                    <div  className='vayu-blocks-slider-default-parent-numbers'>
                                        <div className='vayu-blocks-slider-default-numbers'>1/2</div>
                                    </div>
                                </div>
                            </Button>

                            <Button
                                style={{margin:'3px'}}
                                key={'bullets'}
                                className={`vayu_blocks_animation_panel_button_svg vayu_blocks_animation_panel_button_svg-effect ${imageselectedAnimation === 'bullets' ? 'selected' : ''}`}
                                onClick={() => handleimageAnimationClick('bullets')}
                                title={'bullets'}
                            >
                                <div style={{flexDirection:'column'}} className={`vayu_blocks_animation_panel_svg vayu_blocks_animation_panel_svg-effect vayu-blocks-effect-slider-bullets`}>
                                <h4>Bullets</h4>

                                    <div className='vayu-blocks-slider-default-parent-bullets'>
                                        <div className='vayu-blocks-slider-default-bullets'></div>
                                        <div className='vayu-blocks-slider-default-bullets vayu-blocks-bullets-effect-slider'></div>
                                    </div>
                                </div>
                            </Button>

                            <Button
                                style={{margin:'3px'}}
                                key={'progressbar'}
                                className={`vayu_blocks_animation_panel_button_svg vayu_blocks_animation_panel_button_svg-effect ${imageselectedAnimation === 'progressbar' ? 'selected' : ''}`}
                                onClick={() => handleimageAnimationClick('progressbar')}
                                title={'progressbar'}
                            >
                                <div style={{flexDirection:'column'}} className={`vayu_blocks_animation_panel_svg vayu_blocks_animation_panel_svg-effect vayu-blocks-effect-slider-progressbar`}>
                                <h4>Progressbar</h4>

                                    <div className='vayu-blocks-slider-default-parent-progressbar'>
                                        <div className='vayu-blocks-slider-default-progressbar'></div>
                                        <div className='vayu-blocks-slider-default-progressbar vayu-blocks-progressbar-effect-slider'></div>
                                    </div>
                                </div>
                            </Button>

                    </div>
                </Popover>
            )}
        </div>
    );
};

export default Navigation;
